const doc = [({"en":({"js":({"components":({"users":({"sign_out":({"sign_out":"Sign out", "you_were_signed_out":"You were signed out."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;